import type { FC } from 'react';
import type { ImageProps } from '@theme-ui/components';
import { Image } from '@theme-ui/components';

import downloadIcon from './downloadIcon.svg';

const Icon: FC<ImageProps> = ({ ...props }) => {
  return <Image {...props} src={downloadIcon} />;
};

export default Icon;
